"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _primaryMenu = require("@/api/goods/primaryMenu");
var _sortablejs = require("sortablejs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'primaryMenuManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null
      },
      editVisible: false,
      editForm: {
        id: null,
        name: '',
        nameEn: ''
      },
      editRules: {
        name: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: (0, _defineProperty2.default)({
    handleEdit: function handleEdit(id) {
      var _this = this;
      (0, _primaryMenu.getById)(id).then(function (res) {
        _this.editForm = res.data;
        _this.editVisible = true;
      });
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _primaryMenu.deleteById)(id).then(function (res) {
          if (res.code === 0) {
            _this2.$message.success('删除成功');
            _this2.getList();
          }
        });
      }).catch(function () {});
    },
    handleCreate: function handleCreate() {
      this.editForm = {
        id: null,
        name: '',
        nameEn: ''
      };
      this.editVisible = true;
    },
    saveEntity: function saveEntity() {
      var _this3 = this;
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _primaryMenu.save)(_this3.editForm).then(function (res) {
          if (res.code === 0) {
            _this3.$message.success('操作成功');
            _this3.getList();
            _this3.editVisible = false;
          }
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _primaryMenu.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this4.dataList = response.records;
          _this4.total = response.total;
        }
        setTimeout(function () {
          _this4.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this4.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    }
  }, "handleFilter", function handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  })
};